export enum PARTNER_TYPE {
  CHARITY = 'charity',
  OTHER = 'other_partner',
}
